export enum CustomerUnitStatus {
  PAYMENTAPPROVALPENDING = 1,
  UNIT_ALLOTMENT = 2,
  DISCOUNTREQUESTPENDING = 3,
  PAYMENTPENDING = 4,
  DISCOUNTREJECTED = 5,
  PAYMENTREJECTED = 6,
  PAYMENT_APPROVED = 7,
  PRICEPENDING = 8,
  MILESTONEPENDING = 9
}
